/*
 * @Author: 廿夕 xuanwei@cai-inc.com
 * @Date: 2023-11-20 15:05:26
 * @LastEditors: 玄离 “hongyuanzhong@cai-inc.com“
 * @LastEditTime: 2024-06-12 16:42:47
 * @FilePath: /zcy-claim-front/src/main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** *
 * 'raf/polyfill' 修复IE9的动画问题
 * 'event-source-polyfill' dev下热加载问题
 */
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'; // 导入中文语言包
import 'doraemon/lib/style/v2-compatible-reset';
import dva from 'dva';
import createLoading from 'dva-loading';
import { createBrowserHistory } from 'history';
import throttle from 'lodash/throttle';
import 'raf/polyfill';
import ReactDOM from 'react-dom';
import onError from 'src/common/error';
import address from 'src/common/models/address';
import global from 'src/common/models/global';
import privileges from 'src/common/models/privileges';
import 'src/common/systemConfig';
import 'src/iconfont/iconfont.css';
import 'src/utils/updateJudge';
import { setActionInfo } from 'src/utils/utils';
import './common.less';
import './public-path.js';
import zlbRoute from './router';

// 设置语言环境为中文
dayjs.locale('zh-cn');

require('console-polyfill');

if (__DEV__) {
  require('event-source-polyfill');
}

const isMicro = window.__POWERED_BY_QIANKUN__;
let app;

const pushActionInfo = () => {
  localStorage.removeItem('passwordNotSafe');
  const beginTime = new Date();
  setActionInfo(2, '', beginTime, 0);
};

window.addEventListener('beforeunload', throttle(pushActionInfo, 300000));

const render = async (props = {}) => {
  app = dva({
    history: createBrowserHistory({
      basename: isMicro ? '/main' : '',
    }),
    onError,
  });

  /**
   * loading组件插件
   */
  app.use(createLoading());
  const { container } = props;
  app.model(privileges);
  app.model(address);
  app.model(global);
  app.router(zlbRoute);
  app.start(container ? container.querySelector('#root') : '#root');
};

// eslint-disable-next-line no-underscore-dangle
if (!isMicro) {
  render();
}

export async function bootstrap() {
  // eslint-disable-next-line no-console
  // console.log('claim app bootstraped');
}

export async function mount(props) {
  await render(props);
}

export async function unmount(props) {
  const { container } = props;
  ReactDOM.unmountComponentAtNode(container ? container.querySelector('#root') : '#root');
  // dva状态卸载
  // eslint-disable-next-line no-underscore-dangle
  app._models?.forEach(model => {
    app.unmodel(model.namespace);
  });
}
